<template>
  <div class="details">
    <form-title>代理商详情</form-title>
    <info-panel :padding="24">
      <el-row>
        <el-col :span="col">
          <info-item label="代理商名称">
            {{ result.agentName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="负责人名称">
            {{ result.chargePersonName }}
          </info-item>
        </el-col>
        <el-col :span="col">
          <info-item label="负责人电话">
            {{ result.chargePersonPhone }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="联系地址">
            {{ result.address }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <info-item label="代理区域">
            {{ result.agentAreaList.length > 0 ? result.agentAreaList.map(v => v.provinceCityAreaName).join(';') : '全国' }}
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="col">
          <info-item label="营业执照">
            <el-image
              :src="result.businessLicense"
              :preview-src-list="[result.businessLicense]"
            />
          </info-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <info-item label="备注">
            {{ result.remark }}
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <!-- 代理商人员 -->
    <form-title>代理商人员</form-title>
    <div class="flex">
      <el-button
        type="primary"
        @click="openUserDialog"
      >
        新增代理商人员
      </el-button>
    </div>
    <data-table
      :data="agentUser.list"
      :pagination="false"
      :table-column="agentUserTableColumn"
      @buttonClick="buttonClickUser"
      @changeCheckbox="changeCheckbox"
    />
    <!-- 代理商人员 -->
    <!-- 代理商课程信息 -->
    <form-title>代理商课程信息</form-title>
    <div class="flex">
      <el-button
        type="primary"
        @click="openCourseDialog(null,true)"
      >
        批量新增代理商课程信息
      </el-button>
      <el-button
        type="primary"
        @click="openCourseDialog('checked',true)"
      >
        批量修改代理商课程信息
      </el-button>
      <el-button
        type="primary"
        @click="openCourseDialog(null,false)"
      >
        新增代理商课程信息
      </el-button>
    </div>
    <data-table
      :data="agentCourse.list"
      :pagination="false"
      :table-column="agentCourseTableColumn"
      @buttonClick="buttonClickCourse"
    />
    <!-- 代理商课程信息 -->
    <!-- 代理商分销配置 -->
    <form-title>代理商分销配置</form-title>
    <div class="course-agency-header">
      <div class="l">
        <div class="label">
          课程
        </div>
        <el-select
          v-model="agentCourseAgencySearch.courseId"
          placeholder="请选择课程"
          filterable
          clearable
          @change="agentCourseAgencyPage()"
        >
          <el-option
            v-for="course in courseList"
            :key="course.id"
            :label="course.courseName"
            :value="course.id"
          />
        </el-select>
        <div class="label">
          机构
        </div>
        <el-select
          v-model="agentCourseAgencySearch.agencyId"
          placeholder="请选择机构"
          filterable
          clearable
          @change="agentCourseAgencyPage()"
        >
          <el-option
            v-for="course in agencyList"
            :key="course.id"
            :label="course.value"
            :value="course.id"
          />
        </el-select>
      </div>
      <el-button
        type="primary"
        @click="openCourseAgencyDialog(null)"
      >
        新增代理商分销配置
      </el-button>
    </div>
    <data-table
      :data="agentCourseAgency.list"
      :pagination="false"
      :table-column="agentCourseAgencyTableColumn"
      @buttonClick="buttonClickCourseAgency"
    />
    <!-- 代理商课程信息 -->
    <!-- 新增微信人员 -->
    <wx-user-info
      :dialog-visible.sync="userDialogVisible"
      :check-mobile="false"
      @getWxInfo="getWxInfo"
    />
    <!-- 新增微信人员 -->
    <!-- 新增代理商课程 -->
    <agent-course-dialog
      :dialog-visible.sync="courseDialogVisible"
      :item="courseItem"
      :multiple="agentCourseMultiple"
      @confirm="getInfo()"
      @close="()=> courseItem = {}"
    />
    <!-- 新增代理商课程 -->
    <!-- 新增代理商分销配置 -->
    <agent-course-agency-dialog
      :dialog-visible.sync="courseAgencyDialogVisible"
      :item="courseAgencyItem"
      @confirm="getInfo()"
      @close="()=> courseAgencyItem = {}"
    />
    <!-- 新增代理商分销配置 -->
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import infoItem from '@/components/common/infoItem.vue';
import formTitle from '@/components/common/formTitle.vue';
import dataTable from '@/components/common/dataTable.vue';
import axClient from '@/services';
import types, { courseTypeList } from '@/config';
import wxUserInfo from '@/components/common/userWxInfo.vue';
import agentCourseDialog from './dialog/agentCourseDialog.vue';
import agentCourseAgencyDialog from './dialog/agentCourseAgencyDialog.vue';

export default {
  name: 'AccountDetails',
  components: {
    formTitle,
    infoPanel,
    infoItem,
    dataTable,
    wxUserInfo,
    agentCourseDialog,
    agentCourseAgencyDialog,
  },
  data() {
    return {
      types,
      col: 5,
      result: {
        agentAreaList: [],
      },
      agencyList: [],
      courseList: [],
      courseDialogVisible: false,
      courseAgencyDialogVisible: false,
      userDialogVisible: false,
      agentUser: {},
      agentCourse: {},
      agentCourseAgency: {},
      agentCourseMultiple: false,
      agentCourseAgencySearch: {
        agencyId: null,
        courseId: null,
      },
      courseItem: null,
      courseAgencyItem: null,
      agentUserTableColumn: [
        {
          key: 'userRealName',
          label: '联系电话',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'wechatNickName',
          label: '微信昵称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'mobilePhone',
          label: '联系电话',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'isReceiveAccount',
          label: '是否收款账号',
          dataType: 'component',
          renderProps: '',
          render: () => 'checkbox',
        },
        {
          key: 'isAdmin',
          label: '是否管理员',
          dataType: 'component',
          renderProps: '',
          render: () => 'checkbox',
        },
        {
          key: 'createTime',
          label: '创建时间',
          dataType: 'time',
        },
        {
          key: 'valid',
          label: '状态',
          width: '100px',
          dataType: 'component',
          renderProps: { [types.AGENT_ENABLE]: '启用', [types.AGENT_DISABLE]: '禁用', successKey: types.AGENT_ENABLE },
          render: () => 'status',
        },
        {
          key: 'control',
          label: '操作',
          width: '170px',
          dataType: 'component',
          renderProps: [
            {
              text: '禁用', renderKey: types.AGENT_ENABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '启用', renderKey: types.AGENT_DISABLE, renderProp: 'valid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 1, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
      agentCourseTableColumn: [
        {
          key: 'checked',
          label: '',
          dataType: 'component',
          renderProps: '',
          render: () => 'checkbox',
        },
        {
          key: 'courseName',
          label: '课程名称',
          width: '120px',
          dataType: 'text',
        },

        {
          key: 'courseType',
          label: '课程类型',
          width: '160px',
          dataType: 'function',
          renderProps: '',
          render: (key) => courseTypeList.filter((item) => item.value === key),
        },
        {
          key: 'platformDistributionAmount',
          label: '平台分销金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'agentDistributionAmount',
          label: '代理分销金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'teacherAmount',
          label: '老师分销',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'remark',
          label: '备注',
          width: 'auto',
          dataType: 'text',
          substr: 10,
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'valid',
          label: '状态',
          width: '100px',
          dataType: 'component',
          renderProps: { [types.AGENT_ENABLE]: '启用', [types.AGENT_DISABLE]: '禁用', successKey: types.AGENT_ENABLE },
          render: () => 'status',
        },
        {
          key: 'control',
          label: '操作',
          width: '170px',
          dataType: 'component',
          renderProps: [
            {
              text: '禁用', renderKey: types.AGENT_ENABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '启用', renderKey: types.AGENT_DISABLE, renderProp: 'valid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 1, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 2, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
      agentCourseAgencyTableColumn: [
        {
          key: 'courseName',
          label: '课程名称',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'courseType',
          label: '课程类型',
          width: '160px',
          dataType: 'function',
          renderProps: '',
          render: (key) => courseTypeList.filter((item) => item.value === key),
        },
        {
          key: 'agencyName',
          label: '机构名称',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'agentDistributionAmount',
          label: '代理分销金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'agencyDistributionAmount',
          label: '机构分销',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'remark',
          label: '备注',
          width: 'auto',
          dataType: 'text',
          substr: 10,
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'valid',
          label: '状态',
          width: '100px',
          dataType: 'component',
          renderProps: { [types.AGENT_ENABLE]: '启用', [types.AGENT_DISABLE]: '禁用', successKey: types.AGENT_ENABLE },
          render: () => 'status',
        },
        {
          key: 'control',
          label: '操作',
          width: '170px',
          dataType: 'component',
          renderProps: [
            {
              text: '禁用', renderKey: types.AGENT_ENABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '启用', renderKey: types.AGENT_DISABLE, renderProp: 'valid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 1, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 2, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 人员权限修改
    async changeCheckbox(item) {
      await axClient.agent.agentUserPermissionUpdate({ id: item.id, isAdmin: item.isAdmin, isReceiveAccount: item.isReceiveAccount });
      this.getInfo();
    },
    // 获取查询的微信人员信息
    async getWxInfo(data) {
      const { mobilePhone } = data;
      const res = await axClient.agent.agentUserUpsert({
        agentId: this.$route.params.id,
        mobilePhone,
      });
      if (res) {
        this.$message.success('新增机构人员成功');
      }
      this.getInfo();
    },
    // 代理商人员 table 传递过来的按钮点击
    buttonClickUser(type, item) {
      switch (type) {
        case 0:
          this.confirmUserDialog(item);
          break;
        case 1:
          this.deleteUserDialog(item);
          break;
        default:
          break;
      }
    },
    // 代理课程 table 传递过来的按钮点击
    buttonClickCourse(type, item) {
      switch (type) {
        case 0:
          this.confirmCourseDialog(item);
          break;
        case 1:
          this.deleteCourseDialog(item);
          break;
        case 2:
          this.openCourseDialog(item);
          break;
        default:
          break;
      }
    },
    // 代理课程 table 传递过来的按钮点击
    buttonClickCourseAgency(type, item) {
      switch (type) {
        case 0:
          this.confirmCourseAgencyDialog(item);
          break;
        case 1:
          this.deleteCourseAgencyDialog(item);
          break;
        case 2:
          this.openCourseAgencyDialog(item);
          break;
        default:
          break;
      }
    },
    // 打开代理商分销配置弹窗
    openCourseDialog(item, agentCourseMultiple) {
      this.agentCourseMultiple = agentCourseMultiple;
      if (item === 'checked') {
        this.courseItem = {};
        // 批量修改
        const checkedItems = this.agentCourse.list.filter((v) => v.checked);
        if (checkedItems.length === 0) {
          this.$message.error('批量修改请先选中');
          return;
        }
        // 检查所选中的价格是否一致
        const firstCheckedPrice = checkedItems[0].coursePrice;
        let type = true;
        checkedItems.forEach((checkedItem) => {
          if (checkedItem.coursePrice !== firstCheckedPrice) {
            type = false;
          }
        });
        if (!type) {
          this.$$message.error('所选中的课程价格不一致，不支持批量修改');
          return;
        }
        this.courseItem.courseIds = checkedItems.map((checkedItem) => checkedItem.courseId);
      } else {
        // 批量新增 单独新增
        this.courseItem = item;
      }
      this.courseDialogVisible = true;
    },
    // 打开代理商分销配置弹窗
    openCourseAgencyDialog(item) {
      this.courseAgencyItem = item;
      this.courseAgencyDialogVisible = true;
    },
    // 打开代理商人员新增
    openUserDialog() {
      this.userDialogVisible = true;
    },
    // 详情
    async getInfo() {
      this.result = await axClient.agent.agentgetDetail({
        id: this.$route.params.id,
      });
      if (this.result.agentAreaList === null) {
        this.result.agentAreaList = [];
      }
      this.agentUser = await axClient.agent.agentUserPage({
        agentId: this.$route.params.id,
        valids: [10, 30],
      });
      this.agentCourse = await axClient.agent.agentCourseList({
        agentId: this.$route.params.id,
        valids: [10, 30],
      });
      try {
        this.agentCourse.list.forEach((item) => {
          this.$set(item, 'checked', false);
        });
      } catch (e) {
        console.log(e);
      }
      this.getCourseList();
      this.agentCourseAgencyPage();
    },
    async agentCourseAgencyPage() {
      this.agentCourseAgency = await axClient.agent.agentCourseAgencyPage({
        agentId: this.$route.params.id,
        courseId: this.agentCourseAgencySearch.courseId,
        agencyId: this.agentCourseAgencySearch.agencyId,
        valids: [10, 30],
      });
    },
    // 查询课程列表
    async getCourseList() {
      this.agencyList = [];
      this.courseList = [];
      this.courseList = await axClient.agent.agentCourseListAgentCourse(
        {
          id: this.$route.params.id,
        },
      );
      this.agencyList = await axClient.agent.agentCourseAgencyListAgent({
        id: this.$route.params.id,
      });
      this.agencyList = [{
        id: -1,
        value: '默认配置',
      }, ...this.agencyList];
    },
    // 下架/上架 代理商人员
    confirmUserDialog(item) {
      this.$confirm('确定启用/禁用该代理商人员?', '启用/禁用代理商人员', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id, valid } = item;
        console.log(valid);
        const data = await axClient.agent.agentUserUpdateValid(
          {
            id,
            valid: valid === types.AGENT_DISABLE
              ? types.AGENT_ENABLE : types.AGENT_DISABLE,
          },
        );
        if (data) {
          this.$message.success('启用/禁用成功');
          this.getInfo();
        }
      });
    },
    // 删除 代理商人员
    deleteUserDialog(item) {
      this.$confirm('确定删除该代理商人员?', '删除代理商人员', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id } = item;
        const data = await axClient.agent.agentUserUpdateValid(
          {
            id,
            valid: 20,
          },
        );
        if (data) {
          this.$message.success('删除成功');
          this.getInfo();
        }
      });
    },
    // 下架/上架 代理商课程
    confirmCourseDialog(item) {
      this.$confirm('确定启用/禁用该代理商课程?', '启用/禁用代理商课程', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id, valid } = item;
        console.log(valid);
        const data = await axClient.agent.agentCourseUpdateValid(
          {
            id,
            valid: valid === types.AGENT_DISABLE
              ? types.AGENT_ENABLE : types.AGENT_DISABLE,
          },
        );
        if (data) {
          this.$message.success('启用/禁用成功');
          this.getInfo();
        }
      });
    },
    // 删除 代理商课程
    deleteCourseDialog(item) {
      this.$confirm('确定删除该代理商课程?', '删除代理商课程', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id } = item;
        const data = await axClient.agent.agentCourseUpdateValid(
          {
            id,
            valid: 20,
          },
        );
        if (data) {
          this.$message.success('删除成功');
          this.getInfo();
        }
      });
    },
    // 下架/上架 代理商课程
    confirmCourseAgencyDialog(item) {
      this.$confirm('确定启用/禁用该代理商分销设置?', '启用/禁用代理商分销设置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id, valid } = item;
        console.log(valid);
        const data = await axClient.agent.agentCourseAgencyUpdateValid(
          {
            id,
            valid: valid === types.AGENT_DISABLE
              ? types.AGENT_ENABLE : types.AGENT_DISABLE,
          },
        );
        if (data) {
          this.$message.success('启用/禁用成功');
          this.getInfo();
        }
      });
    },
    // 删除 代理商分销配置
    deleteCourseAgencyDialog(item) {
      this.$confirm('确定删除该代理商分销配置?', '删除代理商分销配置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id } = item;
        const data = await axClient.agent.agentCourseAgencyUpdateValid(
          {
            id,
            valid: 20,
          },
        );
        if (data) {
          this.$message.success('删除成功');
          this.getInfo();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .flex {
    justify-content: flex-end;
    margin-bottom: 20px;
  }
  .course-agency-header{
    justify-content: space-between;
    margin-bottom: 20px;
    display: flex;
    .l{
      display:flex;
      align-items: center;
      .label {
      font-weight: 500;
      font-size: 14px;
      margin-right: 12px;
      min-width: 50px;
    }
    .el-select, .el-date-editor {
      margin-right: 15px;
      max-width: 150px;
      flex: 1;
    }
    }
  }
}
</style>
